export const NEGATIVE_CONTROL = 'Negative Control';
export const POSITIVE_CONTROL = 'Positive Control';
export const headerHeightNumber: number = 48;
export const headerHeight: string = `${headerHeightNumber}px`;
